module.exports = __webpack_public_path__ + "img/sidebar-2.e7cfdd23.jpg";